import React from 'react';
import { createContext, useContext, useRef, useState } from 'react';

const AudioContext = createContext();

export function useAudioContext() {
  return useContext(AudioContext);
}

export function AudioProvider({ children }) {
  const [selectedAudio, setSelectedAudio] = useState(null);
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  const [currentTrackName, setCurrentTrackName] = useState(null);
  // Ref instead of state — avoids re-rendering all consumers on every tick
  const currentTimeRef = useRef(0);

  return (
    <AudioContext.Provider
      value={{
        selectedAudio, setSelectedAudio,
        isPlayerOpen, setIsPlayerOpen,
        currentTrackName, setCurrentTrackName,
        currentTimeRef,
      }}
    >
      {children}
    </AudioContext.Provider>
  );
}
